import { render, staticRenderFns } from "./IcoEdit.vue?vue&type=template&id=03ffacb6"
import script from "./IcoEdit.vue?vue&type=script&lang=js"
export * from "./IcoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports